<div class="flex flex-col p-3 bg-white min-h-full min-w-full rounded">
  <div class="grid grid-cols-1 justify-between items-center">
    <div class="flex font-app-bold">
      <div class="flex items-center justify-between w-full">
        <span class="font-app-regular text-darkest text-sm col-start-1">{{
          "contractCard.nextPayment" | translate
        }}</span>
      </div>
      <span class="text-dark font-app-regular text-sm w-1/2 text-end">
        {{
          contract.paymentDate !== null
            ? (contract.paymentDate | date: "dd/MM/yyyy")
            : ("contractDetails.noPayment" | translate)
        }}
      </span>
    </div>
    <div
      class="flex justify-between items-center pt-1 mt-3"
      *ngIf="contract.paymentDate">
      <span class="font-app-regular text-darkest text-sm">{{ "contractCard.debitAmount" | translate }}</span>
      <span class="text-darkest font-app-bold text-sm">
        {{ contract.nextPaymentAmount | currency: "EUR" : "symbol" : "" : "fr" }}
      </span>
    </div>
    <div
      class="flex justify-between items-center pt-1 mt-3"
      *ngIf="contract.terminationDate">
      <span class="font-app-regular text-darkest text-sm">{{ "contractCard.terminationDate" | translate }}</span>
      <span class="text-dark font-app-regular text-sm">
        {{ contract.terminationDate | date: "dd/MM/yyyy" }}
      </span>
    </div>
    <div
      class="flex justify-between items-center pt-1 mt-3"
      *ngIf="contract.effectiveStartDate && contract.status === 'Signed'">
      <span class="font-app-regular text-darkest text-sm">{{ "contractCard.effectiveDate" | translate }}</span>
      <span class="text-dark font-app-regular text-sm">
        {{ contract.effectiveStartDate | date: "dd/MM/yyyy" }}
      </span>
    </div>
    <div
      class="flex justify-between items-center pt-1 mt-3"
      *ngIf="contract.promotionCode !== null">
      <span class="font-app-regular text-darkest text-sm">{{ "contractCard.promotionCode" | translate }}</span>
      <span class="text-dark font-app-regular text-sm">
        {{ contract.promotionCode }}
      </span>
    </div>
  </div>
</div>

